import { FormikProvider, useFormik } from "formik";
import { PaymentInfo, TYPE_INSTALLMENTS } from "../../../../../../../types/payment.type"
import { useEffect, useMemo, useState } from "react";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { usePaymentForm } from "./customHook/usePaymentForm";
import InputMoney from "../../../../../../../common/components/form/CurrencyInputFormik";
import InputFormik from "../../../../../../../common/components/form/InputFormik";
import ComboBoxFormik from "../../../../../../../common/components/form/ComboBoxFormik";
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading";
import { InstallmentOption, useCalculateInstallmentOptions } from "../../../../../helpers/calculationUtils";
import { weekInstallments } from "../../../../../../../common/services/payments.api";
import { IRenter } from "../../../../../../../types/renter.type";

type PropsInstallmentsPaymetes = {
  data: PaymentInfo;
  paymentOverdue?: PaymentInfo;
  renterId: string;
  renter: IRenter;
  payments: PaymentInfo[];
}

export default function FromInstallmentsPayments(props: PropsInstallmentsPaymetes) {
  const renter = props.renter
  const [, setIsSubmitting] = useState(false);
  const { notifySuccess, notifyError } = useToastContext()
  const weeklyInstallmentCount = renter.createdInstallments.length;

  const desableButton = weeklyInstallmentCount >= 3 ? true : false;

  const { initialValues, } = usePaymentForm({
    data: props.data,
    paymentOverdue: props.paymentOverdue,
    renterId: props.renterId,
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);

        const installmentsData = {
          ...values,
          vehicleId: renter.activationData.vehicle.id,
        }
        const result = await weekInstallments(installmentsData);

        if (!result.ok) {
          notifyError('Erro ao atualizar fatura');
        } else {
          notifySuccess('Fatura atualizada com sucesso!');

        }

      } finally {
        setIsSubmitting(false);
      }
    }
  })

  const weekValue = formik.values.value

  // Obtenha a função memorizada para calcular as opções
  const calculateInstallmentOptions = useCalculateInstallmentOptions();

  // Memorize o array de opções de parcelamento
  const installmentOptions: InstallmentOption[] = useMemo(() => {
    return calculateInstallmentOptions(weekValue, 4);
  }, [weekValue, calculateInstallmentOptions]);

  useEffect(() => {
    // Procura a opção selecionada no array de installments
    const valueSelectedOption = installmentOptions.find(
      (option) => option.value === formik.values.installments
    );

    // Se a opção estiver definida, obtém o valor da parcela (valueOption)
    const installmentAmount = valueSelectedOption?.valueOption || '';

    // Se houver um valor e ele for diferente do atual, atualiza o campo
    if (installmentAmount && formik.values.installmentValue !== installmentAmount) {
      formik.setFieldValue('installmentValue', installmentAmount);
      formik.setFieldValue('installmentType', TYPE_INSTALLMENTS.WEEKLY);
    }
  }, [installmentOptions, formik.values.installments, formik.values.installmentValue, formik]);


  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        {weeklyInstallmentCount > 0 && (
          <div>
            <h2 className="text-redPrimary font-bold">
              Este cliente já parcelou {weeklyInstallmentCount} semanal. O total de parcelamento permitodo são 3.
            </h2>
          </div>
        )}
        {props.data.status === 'OVERDUE' && (
          <div>
            <h2 className="text-redPrimary">
              Esta fatura está atrasada. A alteração do tipo de pagamento deve incluir o valor total (valor + juros),
              pois o Asaas não permite apenas a troca do tipo de pagamento; é necessário também alterar a data para a atual.
            </h2>
          </div>
        )}
        <div className="grid grid-cols-2 gap-2">
          <div className="col-span-2 bg-gray2/20 mt-5 mb-10 p-3 rounded-md shadow">
            <section className="grid gap-2">
              {props.paymentOverdue ? (
                <InputMoney
                  label="valor da fatura com juros"
                  name="value"
                  required={true}
                />
              ) : (
                <InputMoney
                  label="valor da fatura"
                  name="value"
                  required={true}
                />
              )}
              <div>
                <ComboBoxFormik
                  name="installments"
                  label="Escolha a opção de parcelamento:"
                  options={installmentOptions}
                  required={true}
                />
                <InputFormik
                  label="Data de inicio do parcelamento"
                  name="nextDueDate"
                  type="date"
                  required={true}
                  value={formik.values.nextDueDate}
                  onChange={(e) => formik.setFieldValue("nextDueDate", e.target.value)}
                />
              </div>
            </section>
            <div>
              <label className="block text-sm font-medium text-gray-700">Descrição</label>
              <textarea
                required={true}
                name="description"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                rows={3}
                className="resize-none overflow-hidden block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                style={{ height: 'auto', maxHeight: '300px' }}
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = 'auto';
                  target.style.height = `${target.scrollHeight}px`;
                }}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <ButtonWithLoader
            isLoading={formik.isSubmitting}
            disabled={desableButton}
            onClick={formik.handleSubmit}>
            Salvar
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  );
}
